import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.css']
})
export class CustomerDetailsComponent implements OnInit {


  todayDate = new Date();
  date: String;
  todate: String;
  public channelist;
  pipe = new DatePipe("en-US");
  now = Date.now();
  public selectedDate = new FormControl(new Date());
  modifiedCurrentDate: String;
  tomorrow = new Date();

  public user_id;


  prefixList = [
    { value: 'Mr', viewValue: 'Mr.' },
    { value: 'Mrs', viewValue: 'Mrs.' },
    { value: 'Ms', viewValue: 'Ms' }
  ];
  genderList = [
    { value: 'Male', viewValue: "Male" },
    { value: 'Female', viewValue: "Female" },
    { value: 'Gender Non-Conforming', viewValue: "Gender Non-Conforming" },
    { value: 'Trans Male', viewValue: "Trans Male" },
    { value: 'Trans Female', viewValue: "Trans Female" },
    { value: "Don't Know", viewValue: "Don't Know" },
    { value: "Don't Want To Disclose", viewValue: "Don't Want To Disclose" },
  ];



  customerForm = this
    .formBuilder
    .group({
      // prefix: [
      //   '', Validators.required
      // ],
      first_name: [
        '', Validators.required
      ],
      last_name: [
        '', Validators.required
      ],
      phone_no: [
        '', [Validators.required, Validators.pattern('^\d{3}-\d{3}-\d{4}$')]
      ],
      zip_code: [
        '', Validators.required, 
      ],
      email: [
        '', [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]
      ],
      date_of_birth: [
        '', Validators.required
      ],
      gender: [
        '', Validators.required
      ],
    });

  //   gender: [
  //     '', [Validators.required,Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),Validators.min(10000),Validators.max(30000),Validators.minLength(5),Validators.maxLength(5)]
  // ],

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService

  ) {   }

  ngOnInit(): void {
    const now = Date.now();
    const myFormattedDate = this.pipe.transform(now, "yyyy-MM-dd", "en-US");
  }

  dateMselect(type: string, event: MatDatepickerInputEvent<Date>) {
    console.log("Event", event);
    // this.date = this.pipe.transform(event.value, "yyyy-MM-dd");
    this.date = this.pipe.transform(event.value, "yyyy-MM-dd");
    console.log("First Date=" + this.date);
    this.modifiedCurrentDate = this.date;
    console.log("helllooo", this.modifiedCurrentDate);
  }

  formatDate(date) {
    let d = new Date(date),
      month = '' + (
        d.getMonth() + 1
      ),
      year = d.getFullYear(),
      day = '' + d.getDay()
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-');
  }

  saveUser(){
    let saveUserResp;
    this.customerForm.value.date_of_birth = this.date;
    this.customerForm.value.is_signedup = 1;
    console.log(this.customerForm.value, 'save customer');

    if(this.customerForm.value.first_name != "" && this.customerForm.value.last_name != "" &&
    this.customerForm.value.phone_no != "" &&  this.customerForm.value.zip_code !="" && this.customerForm.value.email != ""){
      this.commonService.saveUser(this.customerForm.value).subscribe(
        res => {
          saveUserResp = res.body;
          this.user_id = res.body.data;
          localStorage.setItem('user_id', JSON.stringify(this.user_id));
          localStorage.setItem('isSignUp', 'true');
          localStorage.setItem('customerSignup', JSON.stringify(this.customerForm.value));
          console.log(saveUserResp);
          let tax = localStorage.getItem('tax');
          if(tax == "true"){
            this.router.navigate(['/tax-assistamce'])
          }
          else{
            this.router.navigate(['/otp-password'])

          }
        },err => console.error( 'API Failed' + err)
      )
    }
    else{
      alert('Please fill all the details')
    }
   
  }



  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

}
